import { useDishListsQuery } from '~/libs/gql/queries/dish_lists/dishListsQuery.generated';

export const useFeaturedDishListsData = () => {
  const query = useDishListsQuery({
    variables: {
      pagination: {
        limit: 12,
        offset: 0,
        sortBy: 'createdAt',
        sortDir: 'desc',
      },
    },
  });
  return query;
};
